import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { authenticationRequired } from "@/authentication";
import {
  development
} from "@/dynamic.routes";
import DashboardRoutes from "@/router.dashboard";
import DashboardRoutesFactoring from "@/router.dashboard.factoring";
import RutasPrivadas from "@/routes/rutas.privadas";
import RutasPublicas from "@/routes/rutas.publicas";
import { State } from "./configuration";

Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...RutasPublicas,
    ...RutasPrivadas,
    ...DashboardRoutes.map(route => {
      route.path = `/panel/${route.path}`;
      route.name = `dashboard-${route.name}`;
      route.beforeEnter = authenticationRequired;
      return route;
    }),
    ...DashboardRoutesFactoring.map(route => {
      route.path = `/panel-facto/${route.path}`;
      route.name = `dashboard-factoring-${route.name}`;
      route.beforeEnter = authenticationRequired;
      return route;
    }),
    {
      path: "/404",
      name: "404",
      component: () => import("@/views/404.vue")
    },
    {
      path: "*",
      name: "not-found",
      redirect: "/404"
    },
    {
      path: "/mantenimiento",
      name: "mantenimiento",
      component: () => import("@/views/404-mantain.vue"),
      beforeEnter: development
    },
    {
      path: "/estamos-trabajando",
      name: "trabajando",
      component: () => import("@/views/404-working.vue"),
      beforeEnter: development
    },
  ]
});

router.afterEach((to, from) => {
  if (State == 2) {
    if (to.path != "/mantenimiento") {
      router.push({ path: "/mantenimiento" });
    }
  }
  if (State == 3) {
    if (to.path != "/estamos-trabajando") {
      router.push({ path: "/estamos-trabajando" });
    }
  }
});

router.afterEach((to, from) => {
  if(to.fullPath.indexOf('/panel') == 0){
    store.commit("setShowPanelInv",true)
  } else {
    store.commit("setShowPanelInv",false)
  }
  store.commit("setRoutes", { to: to.path, from: from.path });
});


export default router;
